import request from '@/api/request'
/**
 * 搜索咨询
 */
export const informationEs = (params) => {
  return request({
    url: 'radioweb/app/web/informationEs',
    params,
    method: 'get'
  })
}
/**
 * 搜索名师
 */
export const teacherEs = (params) => {
  return request({
    url: 'radioweb/app/web/teacherEs',
    params,
    method: 'get'
  })
}
/**
 * 搜索面授
 */
export const queryClassEs = (params) => {
  return request({
    url: 'radioweb/app/web/queryClassEs',
    params,
    method: 'get'
  })
}
